<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">招标文件--编制评标办法列表</h2>
            </div>
            <div style="display: flex; gap: 12px;">
                <!-- <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增评标办法</el-button> -->
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionCode" label="标段编号" show-overflow-tooltip />
                <el-table-column label="编制评标办法" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleCompile(scope.row)" class="action-btn">
                            编制评标办法
                        </el-button>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="查看评标办法" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            查看评标办法
                        </el-button>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
    </div>
</template>

<script>
import { getProjectDetail } from '@/api/modules/agent'
import { getSectionList } from '@/api/modules/evaluationstep'
import { getProjectTypeName } from '@/utils/base'
export default {
    name: 'BidEvaluationMethodList',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectId: this.$route.query.projectId,
            tableData: [
            ],
            projectDetail: {},
            pageTitle: '',
            bidSectionCode:''//标段编号
        }
    },
    mounted() {
        this.loadProjectDetail()
        this.getSectionList()
    },
    methods: {


        // 根据项目编码获取标段列表
        getSectionList() {
            getSectionList({ projectCode: this.projectCode }).then(res => {
                if (res.code === 200) {
                    this.tableData = res.data

                }else{
                    this.$message.error(res.msg)
                }
            })
        },

        /**
            * 加载项目详情
            */
        async loadProjectDetail() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
                this.pageTitle = this.generatePageTitle(res.data)
                console.log(this.pageTitle)
            } else {
                this.$message.error('获取项目详情失败')
            }
        },
        //生成页面标题
        generatePageTitle(projectData) {
            const projectTypeName = getProjectTypeName(projectData.projectType)
            return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
        },



        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },
        // 新增评标办法
        handleAdd() {
            this.$router.push({ path: '/bidEvaluationMethod', query: { projectCode: this.projectCode, projectId: this.projectId } })
        },
         // 查看评标办法
        handleView(row) {
            this.handleCompile(row)
        },
        // 编制评标办法
        handleCompile(row) {
            this.bidSectionCode = row.bidSectionCode
            this.$router.push({ path: '/bidEvaluationMethod', query: { projectCode: this.projectCode, projectId: this.projectId ,bidSectionCode:row.bidSectionCode,sectionId:row.id } })
        },

      
        // 跳转页面
        handleJumpPage() {
            if (this.jumpPage && this.jumpPage > 0) {
                this.currentPage = this.jumpPage
                this.loadData()
            }
        },

        // 加载数据
        loadData() {
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

// ============================================
// 应用极简灰度主题
// ============================================
.agent-page {
    .apply-minimal-gray-theme();
}

// ============================================
// 页面特定样式
// ============================================

// 页面头部优化（带按钮组）
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;

        &:hover {
            transform: translateY(-1px);
        }

        &:active {
            transform: translateY(0);
        }
    }
}
</style>
